import React, { useState } from 'react';

const TestCode = () => {
  const [code, setCode] = useState('BLOG504M1');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const checkCode = async () => {
    try {
      setLoading(true);
      setError(null);
      setResult(null);
      
      // Call the diagnostic function
      const response = await fetch(`https://us-central1-game-pre-battle.cloudfunctions.net/checkCode?code=${code}`);
      const data = await response.json();
      
      setResult(data);
    } catch (err) {
      console.error('Error checking code:', err);
      setError('An error occurred while checking the code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen">
      <div className="max-w-md mx-auto mt-8">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6">
          <h1 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Test Code Validity</h1>
          
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Reward Code
            </label>
            <div className="flex">
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                placeholder="Enter code"
              />
              <button
                onClick={checkCode}
                disabled={loading || !code}
                className="bg-blue-600 text-white px-4 py-2 rounded-r-md hover:bg-blue-700 disabled:bg-blue-300 dark:disabled:bg-blue-800"
              >
                {loading ? 'Checking...' : 'Check'}
              </button>
            </div>
          </div>
          
          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-md text-red-600 dark:bg-red-900/30 dark:border-red-800 dark:text-red-400 mb-4">
              {error}
            </div>
          )}
          
          {result && (
            <div className="p-4 bg-gray-50 dark:bg-gray-700 rounded-md">
              <h2 className="text-lg font-semibold mb-2">Result:</h2>
              <pre className="whitespace-pre-wrap text-sm bg-gray-100 dark:bg-gray-800 p-3 rounded overflow-auto">
                {JSON.stringify(result, null, 2)}
              </pre>
              
              {result.exists && result.active && (
                <div className="mt-4 p-3 bg-green-50 dark:bg-green-900/30 rounded-md text-green-700 dark:text-green-400">
                  Code is valid and active! ✅
                </div>
              )}
              
              {result.exists && !result.active && (
                <div className="mt-4 p-3 bg-yellow-50 dark:bg-yellow-900/30 rounded-md text-yellow-700 dark:text-yellow-400">
                  Code exists but is not active! ⚠️
                </div>
              )}
              
              {!result.exists && (
                <div className="mt-4 p-3 bg-red-50 dark:bg-red-900/30 rounded-md text-red-700 dark:text-red-400">
                  Code does not exist in the database! ❌
                </div>
              )}
            </div>
          )}
          
          <div className="mt-6">
            <h2 className="text-lg font-semibold mb-2">Debug Info:</h2>
            <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600 dark:text-gray-300">
              <li>Frontend URL: <code>https://redeemcode-o4zxi7jnaa-uc.a.run.app/redeem-code</code></li>
              <li>New URL: <code>https://redeemcode-vji7sqed4a-uc.a.run.app</code></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestCode; 